import { render, staticRenderFns } from "./KG4002Component.vue?vue&type=template&id=77016dde&scoped=true&"
import script from "./KG4002Component.vue?vue&type=script&lang=js&"
export * from "./KG4002Component.vue?vue&type=script&lang=js&"
import style0 from "./KG4002Component.vue?vue&type=style&index=0&id=77016dde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77016dde",
  null
  
)

export default component.exports